import { Link } from "react-router-dom";

const siteLinks = [
  { label: "首页", path: "/" },
  { label: "电影分类", path: "/category" },
  { label: "影评专题", path: "/special" },
  { label: "搜索结果", path: "/search" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

const friendLinks = [
  { label: "豆瓣电影", url: "https://movie.douban.com" },
  { label: "IMDb", url: "https://www.imdb.com" },
  { label: "Mtime 时光网", url: "https://www.mtime.com" },
  { label: "猫眼电影", url: "https://maoyan.com" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100 mt-16 pb-20 md:pb-0">
      <div className="w-full px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-10 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-xl">爱的色放电影</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200">
              爱的色放电影是一个专注于爱情题材的影视资讯平台，提供高清电影介绍、剧情解析、专业影评与观影指南，帮助你在光影流转间，读懂每一段爱情。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">·</span> 网站导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {siteLinks.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer flex items-center gap-1.5"
                  >
                    <i className="ri-arrow-right-s-line text-accent-400"></i>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-base mb-4">
              <span className="text-accent-400">·</span> 友情链接
            </h4>
            <ul className="flex flex-col gap-2.5">
              {friendLinks.map((l) => (
                <li key={l.url}>
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noopener"
                    className="text-sm text-background-200 hover:text-background-50 transition-colors flex items-center gap-1.5"
                  >
                    <i className="ri-external-link-line text-accent-400"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {new Date().getFullYear()} 爱的色放电影 · 高清电影介绍与影评聚合平台</p>
          <p>本站影评与资料仅供学习交流，相关版权归原影片方所有</p>
        </div>
      </div>
    </footer>
  );
}